import Error, { ErrorType } from "@components/global/new/Error/Error";
import { Input } from "@components/global/new/Input/Input";
import Title from "@components/global/new/Title/Title";
import WithModal, { CommonModalPropsI } from "@components/HOC/withModals";
import { MODALS_ENUM } from "@constants/Modals";
import mainLocationsStore from "@mobx/store/locations";
import { useGlobalNotifs } from "@utils/hooks/useGlobalNotifs";
import { isCurrentStr } from "@utils/isRussianLang";
import { makeNotifs } from "@utils/makeNotifs";
import { Button } from "antd";
import { observer } from "mobx-react-lite";
import { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import styles from "./AddBuildingModal.module.scss";

export interface IAddBuildingModal3Props extends CommonModalPropsI { }

interface FormValues {
  name: HTMLInputElement;
}

interface Elems extends HTMLFormControlsCollection, FormValues { }

interface MyForm extends HTMLFormElement {
  readonly elements: Elems;
}

const useControl = (
  props: IAddBuildingModal3Props
) => {
  const locationStore = mainLocationsStore?.activeLocation;
  const { onSuccess } = useGlobalNotifs();
  const { ok, errors: notifsErrors } = makeNotifs();
  const [errors, setErrors] = useState<ErrorType>();

  const formHandle = async (e: React.FormEvent<MyForm>) => {
    e.preventDefault();
    const elems = e.currentTarget.elements;
    const name = elems.name.value.toLocaleUpperCase();
    if (!isCurrentStr(name)) {
      setErrors({ ownError: [notifsErrors.symbols] });
      return;
    }

    const res = await locationStore?.addBuilding(name);
    if (!res) return;
    onSuccess(ok.success);
    props.handleDestroy();
  };

  return {
    loading: !!locationStore?.isLoading,
    errors,

    formHandle,
  };
};

const AddBuildingModal3 = observer((props: IAddBuildingModal3Props) => {
  const { formatMessage } = useIntl();
  const control = useControl(props);
  return (
    <div className={styles.wrapper}>
      <Title>{formatMessage({ id: "modal.create_object.title" })}</Title>

      <form onSubmit={control.formHandle} className={styles.content}>
        <Input
          label={formatMessage({ id: "modal.create_object.building_id" })}
          type='text'
          className={styles.name}
          id='name'
        />

        <Button htmlType='submit' type="primary" loading={control.loading} className={styles.btn}>
          {formatMessage({ id: "modal.create_object.btn" })}
        </Button>
      </form>
      {control.errors && <Error errors={control.errors} />}
    </div>
  );
});

AddBuildingModal3.displayName = "AddBuildingModal3";

export default WithModal(MODALS_ENUM.ADD_BUILDING_MOBX, AddBuildingModal3);
